import en from './locales/en.json';
import de from './locales/de.json';

export const totalBalanceLocales = {
  en: { totalBalance: en },
  de: { totalBalance: de },
};

export { default as TotalBalanceCard } from './TotalBalanceCard.vue';
export { default as TotalBalanceOnboardingContent } from './components/TotalBalanceOnboardingContent.vue';
export { default as TotalBalancePhoneVerificationDialog } from './components/TotalBalancePhoneVerificationDialog.vue';
export * from './useTotalBalanceAccessViewModel';
export * from './total-balance.types';
